import size from './size';
export var device = {
    mobileS: "(min-width: " + size.mobileS + ")",
    mobileL: "(min-width: " + size.mobileL + ")",
    tablet: "(min-width: " + size.tablet + ")",
    laptop: "(min-width: " + size.laptop + ")",
    heightMobileL: "(max-height: " + size.mobileL + ")",
    heightTablet: "(min-height: " + size.tablet + ")",
    maxMobileS: "(max-width: " + size.mobileS + ")",
};
export default device;
